// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2iEgZ","additionalInfo":"AgreementModal_additionalInfo__3bASu"};